import { startLoading, stopLoading, showNotification, serverErrorMessage, showAlert, catchHandler } from "@/utils/helpers";
import dataService from "../../api";


export default {
    namespaced: true,
    state: {
        services: [],
        service: {
            serviceName: null,
            departmentName: null,
            price: null,
            createdBy: null,
            createdOn: null,
            status: null,
            servicesDetails: []
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.services.findIndex(i => i.id === id)
    },
    mutations: {
        SET_ITEMS: (state, data) => state.services = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_ITEM: (state, viewData) => state.service = viewData,
        ADD: (state, addedData) => state.services.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.services.splice(index, 1, updateData),
        DELETE: (state, index) => state.services.splice(index, 1),
    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                const response = await dataService.services.getAll(paramsString);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEMS', response.data.services);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            startLoading()
            try {
                commit('SET_ITEM', {
                    servicesDetails: []
                });
                const response = await dataService.services.getDetails(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEM', response.data.service);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async get({ commit }, id) {
            startLoading()
            try {
                commit('SET_ITEM', {
                    servicesDetails: []
                });
                const response = await dataService.services.getDetails(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEM', response.data.service);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getForEdit(_, id) {
            startLoading();
            try {

                const response = await dataService.services.getForEdit(id);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                return Promise.resolve(response.data.service);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async add({ commit }, payload) {
            try {
                startLoading()
                const response = await dataService.services.add(payload);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                commit('ADD', response.data.service);
            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        async edit({ commit, getters }, { id, payload }) {
            try {
                startLoading()
                const response = await dataService.services.edit(id, payload);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.service });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        async delete({ commit, getters }, id) {
            try {
                startLoading()
                const response = await dataService.services.delete(id);
    
                stopLoading()
    
                if (!response.data.statusCode) {
                   showAlert(serverErrorMessage);
                   return;
                }
    
                showNotification(response.data.message);
    
    
                const index = getters.index(id);
                commit("DELETE", index);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        ///////////////////////////////////////////////////////////////////
        async getServiesDetails(_, id) {
            startLoading();
            try {

                const response = await dataService.services.getServiesDetails(id);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                return Promise.resolve(response.data.service);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async serviesDetails({ commit, getters }, { id, payload }) {
            try {
                startLoading()
                const response = await dataService.services.ServiesDetails(id, payload);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.service });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
    },
};
